module.exports = __webpack_public_path__ + "img/4.d9f8990a.jpg";